<template>
    <div class="c-o-request-section c-o-request-section--information">
        <div class="c-o-request-section__inner">
            <div
                class="c-o-request-section__main c-o-request-section__main--large u-padding-3 box"
            >
                <div class="sj-contract-status">
                    <atom-title :icon="status.icon">{{
                        status.header
                    }}</atom-title>
                    <p>{{ status.infoText }}</p>
                    <button-group>
                        <atom-button
                            v-if="contractUrl"
                            label="Visa avtal"
                            :class="
                                'c-a-button--theme-secondary-light c-a-button--hollow-thin u-margin-top-2'
                            "
                            class="c-a-button c-a-button--theme-primary"
                            :icon="'file-pdf'"
                            @buttonClicked="redirectToContract"
                        />
                    </button-group>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from "../atoms/AtomIcon.vue";
import AtomButton from "../atoms/AtomButton.vue";
import { mapGetters } from "vuex";
import ButtonGroup from "./MoleculeButtonGroup.vue";
import AtomTitle from "../atoms/AtomTitle.vue";

import {
    ABORT_CONTRACT_REQUEST,
    GET_CONTRACT,
    GET_CASE,
    GET_CONTRACT_URL
} from "../../../store/store-models/contract-model";

export default {
    props: ["company"],
    components: {
        Icon,
        AtomButton,
        ButtonGroup,
        AtomTitle
    },
    data() {
        return {
            statusTemplate: {
                customerStatusAwaitsProposal: {
                    header: `Du väntar på avtalsförslag från ${this.company.CompanyName}`,
                    icon: "info",
                    infoText: `${this.company.CompanyName} har blivit informerad och kommer skicka ett mail till dig med ett avtalsförslag. Tänk på att det kan ta några dagar. `
                },
                customerStatusContractToSign: {
                    header: `Dags att signera!`,
                    icon: "file-signature",
                    infoText: `${this.company.CompanyName} har skickat ett avtalsförslag till dig! Läs igenom avtalet noggrant. Du godkänner och signerar avtalet med BankID. Skulle du vilja ändra något i avtalet klickar du i stället på “Jag kan inte underteckna” och lämnar ett meddelande till hantverkaren om vad du vill ha ändrat. `
                },
                customerStatusContractSigned: {
                    header: `Avtal signerat!`,
                    icon: "check_circle",
                    infoText: `Här hittar du en kopia av ert signerade avtal. En kopia av avtalet lagras hos BraByggare och vi rekommenderar att även du sparar en egen kopia. Gå in på avtalet och klicka på “Ladda ned” högst upp.
          Glöm inte bort att lämna ett omdöme på hantverkaren när jobbet är klart, det hjälper andra i valet av hantverkare!`
                },
                AwaitsChanges: {
                    header: `Inväntar reviderat avtal från ${this.company.CompanyName}`,
                    icon: "info",
                    infoText: `Du får ett mail så snart hantverkaren skickar ett nytt avtalsförslag till dig.`
                }
            }
        };
    },
    computed: {
        ...mapGetters({
            contract: GET_CONTRACT,
            caseProposal: GET_CASE,
            contractUrl: GET_CONTRACT_URL
        }),
        status: function() {
            let displayStatus = "";
            if (this.contract.IsSignedByAllParties)
                displayStatus = "customerStatusContractSigned";
            else if (this.contractUrl)
                displayStatus = "customerStatusContractToSign";
            else if (
                (this.contract.version > 1 && !this.contract.isSent) ||
                (this.contract.version > 1 && !this.contract.isDraft)
            )
                displayStatus = "AwaitsChanges";
            else displayStatus = "customerStatusAwaitsProposal";

            return this.statusTemplate[displayStatus];
        }
    },
    methods: {
        redirectToContract: function() {
            window.open(this.contractUrl);
        }
    }
};
</script>
<style scoped>
.sj-contract-status p {
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 21px;
    width: 80%;
}

.sj-contract-status h2 {
    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 23px;
    line-height: 16px;
}

.box {
    background: #fafafa;
    border: 1px solid #e6e6e6;
    box-sizing: border-box;
    position: relative;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
}
.box >>> h3 {
    margin-top: 0;
    margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeContractStatus.vue